/* Puptein theme scripts. No dependencies. */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var P = window.Puptein || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, cartType: 'drawer' };

  function formatMoney(cents) {
    var fmt = P.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (key === 'amount_with_comma_separator') return value.replace('.', ',');
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
  }

  /* ---------- Header height var (mobile menu top) ---------- */
  function setHeaderBottom() {
    var h = $('[data-header]');
    if (!h) return;
    var r = h.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-bottom', Math.max(r.bottom, 0) + 'px');
  }
  window.addEventListener('resize', setHeaderBottom);
  window.addEventListener('scroll', setHeaderBottom, { passive: true });

  /* ---------- Announcement rotator ---------- */
  function initAnnounce() {
    $$('[data-announce]').forEach(function (bar) {
      var msgs = $$('.announce__msg', bar);
      if (msgs.length < 2) return;
      var i = 0, speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000, timer;
      function show(n) {
        msgs[i].classList.remove('is-active');
        i = (n + msgs.length) % msgs.length;
        msgs[i].classList.add('is-active');
      }
      function start() { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, speed); }
      var prev = $('[data-announce-prev]', bar), next = $('[data-announce-next]', bar);
      prev && prev.addEventListener('click', function () { show(i - 1); start(); });
      next && next.addEventListener('click', function () { show(i + 1); start(); });
      bar.addEventListener('mouseenter', function () { clearInterval(timer); });
      bar.addEventListener('mouseleave', start);
      start();
    });
  }

  /* ---------- Mega menu ---------- */
  function initMega() {
    var items = $$('[data-mega]');
    var closeAll = function (except) {
      items.forEach(function (it) {
        if (it === except) return;
        var b = $('.dnav__link', it), m = $('.mega', it);
        b.setAttribute('aria-expanded', 'false'); m.hidden = true;
      });
    };
    items.forEach(function (it) {
      var btn = $('.dnav__link', it), menu = $('.mega', it), t;
      var open = function () { clearTimeout(t); closeAll(it); btn.setAttribute('aria-expanded', 'true'); menu.hidden = false; };
      var close = function () { t = setTimeout(function () { btn.setAttribute('aria-expanded', 'false'); menu.hidden = true; }, 120); };
      it.addEventListener('mouseenter', open);
      it.addEventListener('mouseleave', close);
      btn.addEventListener('click', function () { btn.getAttribute('aria-expanded') === 'true' ? (menu.hidden = true, btn.setAttribute('aria-expanded', 'false')) : open(); });
      it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) close(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    var mnav = $('[data-mnav]');
    if (mnav) {
      mnav.addEventListener('toggle', function () {
        setHeaderBottom();
        document.body.style.overflow = mnav.open ? 'hidden' : '';
      });
    }
  }

  /* ---------- Search pop ---------- */
  function initSearch() {
    var pop = $('[data-search-pop]');
    if (!pop) return;
    $$('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); pop.hidden = !pop.hidden; if (!pop.hidden) $('input[type="search"]', pop).focus(); });
    });
    $$('[data-search-close]', pop).forEach(function (b) { b.addEventListener('click', function () { pop.hidden = true; }); });
  }

  /* ---------- Cart drawer ---------- */
  var drawer;
  function openDrawer() {
    drawer = drawer || $('[data-cart-drawer]');
    if (!drawer) { window.location.href = P.routes.cart; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var panel = $('.drawer__panel', drawer); panel && panel.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function renderDrawer(html) {
    drawer = drawer || $('[data-cart-drawer]');
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer-inner]', doc);
    var current = $('[data-cart-drawer-inner]', drawer);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var count = $('[data-cart-count-source]', drawer);
    if (count) updateCount(parseInt(count.textContent, 10) || 0);
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }
  function refreshDrawer() {
    return fetch(P.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data['cart-drawer']); });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && P.cartType === 'drawer' && $('[data-cart-drawer]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    var q = e.target.closest('[data-qty-change]');
    if (q && !q.disabled) {
      var lineIdx = parseInt(q.dataset.lineIndex, 10), want = parseInt(q.dataset.qtyChange, 10);
      var showErr = function (msg) {
        var li = $$('[data-line-index="' + lineIdx + '"]', drawer || document)[0];
        li = li && li.closest('li');
        if (!li) return;
        var el = $('.line__err', li);
        if (!el) { el = document.createElement('p'); el.className = 'line__err'; el.setAttribute('role', 'alert'); (li.querySelector('.qty') || li).insertAdjacentElement('afterend', el); }
        el.textContent = msg;
      };
      drawer && drawer.classList.add('is-loading');
      fetch(P.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: lineIdx, quantity: want, sections: 'cart-drawer' })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { showErr(res.body.description || res.body.message || 'Could not update your cart. Please try again.'); return; }
          var data = res.body;
          if (data.sections) renderDrawer(data.sections['cart-drawer']); else refreshDrawer();
          var line = data.items && data.items[lineIdx - 1];
          if (want > 0 && line && line.quantity < want) showErr('Only ' + line.quantity + ' in stock right now, so we kept it at ' + line.quantity + '.');
        })
        .catch(function () { showErr('Could not update your cart. Please try again.'); })
        .finally(function () { drawer && drawer.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || P.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
    e.preventDefault();
    var btn = $('[data-add-btn]', form) || $('[type="submit"]', form) || document.querySelector('[form="' + form.id + '"]');
    btn && btn.classList.add('is-loading');
    var fd = new FormData(form);
    if (!fd.get('selling_plan')) fd.delete('selling_plan');
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch(P.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        var errEl = $('.form-error', form);
        if (!res.ok) {
          if (!errEl) { errEl = document.createElement('p'); errEl.className = 'form-error'; errEl.setAttribute('role', 'alert'); form.appendChild(errEl); }
          errEl.textContent = res.body.description || res.body.message || 'Could not add to cart. Please try again.';
          throw 'handled';
        }
        if (errEl) errEl.remove();
        if (res.body.sections) renderDrawer(res.body.sections['cart-drawer']); else return refreshDrawer();
      })
      .then(function () { openDrawer(); })
      .catch(function (err) { if (err !== 'handled') form.submit(); })
      .finally(function () { btn && btn.classList.remove('is-loading'); });
  });

  /* ---------- Sliders ---------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (s) {
      var track = $('.slider__track', s);
      var step = function () { var slide = $('.slider__slide:not(.is-filtered)', track); return slide ? slide.getBoundingClientRect().width + 20 : track.clientWidth; };
      var syncStatic = function () { s.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 2); };
      syncStatic(); window.addEventListener('resize', syncStatic);
      var prev = $('[data-slider-prev]', s), next = $('[data-slider-next]', s);
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
    // Featured product tabs
    $$('[data-fp-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var sec = tab.closest('.fp'), handle = tab.dataset.fpTab;
        $$('[data-fp-tab]', sec).forEach(function (t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab); });
        $$('.slider__slide', sec).forEach(function (sl) {
          var list = (sl.dataset.collections || '').split(' ');
          sl.classList.toggle('is-filtered', handle !== 'all' && list.indexOf(handle) === -1);
        });
        var tr = $('.slider__track', sec); tr && tr.scrollTo({ left: 0 });
      });
    });
  }

  /* ---------- Tabs (ingredient spotlight) ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (wrap) {
      $$('[data-tab]', wrap).forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.dataset.tab;
          $$('[data-tab]', wrap).forEach(function (t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab); });
          $$('[data-panel]', wrap).forEach(function (p) { var on = p.dataset.panel === id; p.hidden = !on; p.classList.toggle('is-active', on); });
        });
      });
    });
  }

  /* ---------- Quiz ---------- */
  function initQuiz() {
    $$('[data-quiz]').forEach(function (q) {
      var age = null;
      var hasDogs = !!$('[data-quiz-step="dogs"]', q);
      // Progress dot for each step (the optional dogs step sits between age and needs)
      var dotOf = function (n) { return ({ '1': 1, 'dogs': 2, '2': hasDogs ? 3 : 2, 'other': hasDogs ? 3 : 2, '3': hasDogs ? 4 : 3 })[String(n)] || 1; };
      var go = function (n) {
        $$('[data-quiz-step]', q).forEach(function (s) { var on = s.dataset.quizStep === String(n); s.hidden = !on; s.classList.toggle('is-active', on); });
        $$('[data-quiz-dot]', q).forEach(function (d) { d.classList.toggle('is-active', parseInt(d.dataset.quizDot, 10) <= dotOf(n)); });
      };
      $$('[data-quiz-age]', q).forEach(function (b) { b.addEventListener('click', function () { age = b.dataset.quizAge; go(hasDogs ? 'dogs' : 2); }); });
      $$('[data-quiz-need]', q).forEach(function (b) {
        b.addEventListener('click', function () {
          var id = b.dataset.quizNeed;
          $$('[data-quiz-result]', q).forEach(function (r) { r.hidden = r.dataset.quizResult !== id; });
          $$('[data-quiz-senior-only]', q).forEach(function (el) { el.hidden = age !== 'senior'; });
          go(3);
        });
      });
      $$('[data-quiz-back]', q).forEach(function (b) { b.addEventListener('click', function () { go(b.dataset.quizBack); }); });
      $$('[data-quiz-restart]', q).forEach(function (b) { b.addEventListener('click', function () { age = null; go(1); }); });
    });
  }

  /* ---------- Product page ---------- */
  function initPDP() {
    $$('[data-pdp]').forEach(function (pdp) {
      // Gallery
      var slides = $$('[data-gallery-slide]', pdp), thumbs = $$('[data-gallery-thumb]', pdp), idx = 0;
      var show = function (n) {
        if (!slides.length) return;
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        var v = $$('video', pdp); v.forEach(function (vid) { vid.pause(); });
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.galleryThumb, 10)); }); });
      var gp = $('[data-gallery-prev]', pdp), gn = $('[data-gallery-next]', pdp);
      gp && gp.addEventListener('click', function () { show(idx - 1); });
      gn && gn.addEventListener('click', function () { show(idx + 1); });
      var stage = $('.pdp__stage', pdp), sx = null;
      if (stage) {
        stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1)); sx = null; });
      }

      // Data
      var dataEl = $('[data-product-json]', pdp), data = { variants: [] };
      try { data = JSON.parse(dataEl.textContent); } catch (err) {}
      var form = $('[data-product-form]', pdp);
      if (!form) return;
      var variantInput = $('[data-variant-input]', form);
      var planInput = $('[data-selling-plan-input]', form);
      var addBtn = $('[data-add-btn]', form), addLabel = $('[data-add-label]', form);
      var currentVariant = function () { var id = parseInt(variantInput.value, 10); return data.variants.filter(function (v) { return v.id === id; })[0]; };

      var refreshPrices = function () {
        var v = currentVariant(); if (!v) return;
        var one = $('[data-onetime-price]', form); if (one) one.textContent = formatMoney(v.price);
        var sel0 = $('input[name="purchase_option"]:checked', form);
        var shown = (sel0 && sel0.value && v.plans && v.plans[sel0.value] !== undefined) ? v.plans[sel0.value] : v.price;
        var p = $('[data-price]', pdp); if (p) p.textContent = formatMoney(shown);
        var cp = $('[data-compare-price]', pdp); if (cp) { if (v.compare > shown) { cp.hidden = false; cp.textContent = formatMoney(v.compare); } else { cp.hidden = true; } }
        var per = $('[data-per-serving]', pdp); if (per) { var n = parseInt(per.dataset.perServing, 10) || 1; per.textContent = formatMoney(Math.floor(shown / n)) + ' ' + (per.dataset.perLabel || ''); }
        $$('.po__opt input[name="purchase_option"]', form).forEach(function (r) {
          if (!r.value) return;
          var price = v.plans && v.plans[r.value];
          var el = $('.po__price strong', r.closest('.po__opt'));
          if (el && price !== undefined) el.textContent = formatMoney(price);
        });
        var sel = $('input[name="purchase_option"]:checked', form);
        var stickyPrice = $('[data-sticky-price]', pdp);
        if (stickyPrice) stickyPrice.textContent = formatMoney(sel && sel.value && v.plans[sel.value] !== undefined ? v.plans[sel.value] : v.price);
        if (addBtn) { addBtn.disabled = !v.available; if (addLabel) addLabel.textContent = v.available ? 'Add to cart' : (addLabel.dataset.soldout || 'Sold out'); }
      };

      $$('input[name="variant_choice"]', form).forEach(function (r) {
        r.addEventListener('change', function () {
          variantInput.value = r.value;
          var url = new URL(window.location.href); url.searchParams.set('variant', r.value);
          window.history.replaceState({}, '', url.toString());
          refreshPrices();
        });
      });
      $$('input[name="purchase_option"]', form).forEach(function (r) {
        r.addEventListener('change', function () {
          $$('.po__opt', form).forEach(function (o) { o.classList.toggle('is-active', $('input', o).checked); });
          if (planInput) planInput.value = r.value;
          refreshPrices();
        });
      });

      // Quantity
      var qty = $('[data-qty-input]', form);
      $$('[data-qty-step]', form).forEach(function (b) {
        b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10)); });
      });

      // Sticky ATC
      var sticky = $('[data-sticky-atc]', pdp);
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var past = !en.isIntersecting && en.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', past);
            sticky.setAttribute('aria-hidden', !past);
          });
        }).observe(addBtn);
      }
      refreshPrices();
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecs() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.querySelector('.card')) return;
      var load = function (url, fallback) {
        fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = $('[data-recommendations]', doc);
          if (inner && inner.querySelector('.card')) { el.innerHTML = inner.innerHTML; }
          else if (fallback) { load(url.replace('intent=complementary', 'intent=related'), false); }
        }).catch(function () {});
      };
      load(el.dataset.url, el.dataset.url.indexOf('intent=complementary') > -1);
    });
  }

  /* ---------- Collection filters (auto-submit) ---------- */
  function initCollection() {
    var form = $('[data-coll-form]');
    if (!form) return;
    form.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(form));
      window.location.search = params.toString();
    });
  }

  function init() {
    setHeaderBottom();
    initAnnounce(); initMega(); initSearch(); initSliders(); initTabs();
    initQuiz(); initPDP(); initRecs(); initCollection();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor: re-init when sections reload
  document.addEventListener('shopify:section:load', function () { initAnnounce(); initSliders(); initTabs(); initQuiz(); initPDP(); initRecs(); });
})();
